export const ar = {
  // Navigation (Arabic)
  explore: 'استكشف',
  search: 'بحث',
  create: 'إنشاء منشور',
  messages: 'الرسائل',
  notifications: 'الإشعارات',
  settings: 'الإعدادات',
  profile: 'الملف الشخصي',
  logout: 'تسجيل الخروج',
  home: 'الرئيسية',
  
  // Authentication
  signin: 'تسجيل الدخول',
  signup: 'إنشاء حساب',
  login: 'تسجيل الدخول',
  register: 'التسجيل',
  email: 'البريد الإلكتروني',
  password: 'كلمة المرور',
  confirmPassword: 'تأكيد كلمة المرور',
  firstName: 'الاسم الأول',
  lastName: 'اسم العائلة',
  forgotPassword: 'نسيت كلمة المرور؟',
  alreadyHaveAccount: 'لديك حساب بالفعل؟ سجل الدخول',
  dontHaveAccount: 'ليس لديك حساب؟ أنشئ حساباً',
  
  // Posts & Content
  recent: 'الأحدث',
  trending: 'الرائج',
  popular: 'الشائع',
  like: 'إعجاب',
  likes: 'إعجابات',
  comment: 'تعليق',
  comments: 'التعليقات',
  share: 'مشاركة',
  delete: 'حذف',
  edit: 'تعديل',
  post: 'منشور',
  posts: 'المنشورات',
  title: 'العنوان',
  content: 'المحتوى',
  tags: 'العلامات',
  noBlogsFound: 'لم يتم العثور على مدونات. جرب البحث عن شيء آخر أو أنشئ الأول!',
  
  // AI Assistant
  quickActions: 'إجراءات سريعة',
  writeCaption: 'كتابة تسمية توضيحية',
  suggestTopics: 'اقتراح مواضيع',
  improveContent: 'تحسين المحتوى',
  creativeIdeas: 'أفكار إبداعية',
  clearChat: 'مسح المحادثة',
  aiWritingAssistant: 'مساعد الكتابة بالذكاء الاصطناعي',
  poweredByGroq: 'مدعوم بـ GROQ AI',
  aiGreeting: 'مرحباً! أنا مساعد الكتابة بالذكاء الاصطناعي. يمكنني مساعدتك في إنشاء محتوى جذاب، وكتابة التسميات التوضيحية، واقتراح مواضيع المنشورات، وتحسين كتابتك. ما الذي تود العمل عليه اليوم؟',
  askMeToHelp: 'اطلب مني المساعدة في المحتوى أو التسميات التوضيحية أو المواضيع أو الكتابة...',
  aiThinking: 'الذكاء الاصطناعي يفكر...',
  
  // Chat & Messages
  chat: 'المحادثة',
  noConversationsYet: 'لا توجد محادثات بعد',
  ideafluxChat: 'محادثة IdeaFlux',
  typeMessage: 'اكتب رسالة...',
  sendMessage: 'إرسال الرسالة',
  connectingToChat: 'الاتصال بالمحادثة...',
  
  // Notifications
  noNotificationsYet: 'لا توجد إشعارات بعد.',
  markAllRead: 'تحديد الكل كمقروء',
  clearAll: 'مسح الكل',
  
  // Settings
  accountSettings: 'إعدادات الحساب',
  displayName: 'اسم العرض',
  emailAddress: 'عنوان البريد الإلكتروني',
  languagePreference: 'تفضيل اللغة',
  privacySecurity: 'الخصوصية والأمان',
  notificationPreferences: 'تفضيلات الإشعارات',
  allowDirectMessages: 'السماح بالرسائل المباشرة',
  letOthersMessage: 'السماح للمستخدمين الآخرين بإرسال رسائل خاصة إليك',
  likesOnPosts: 'الإعجابات على المنشورات',
  commentsOnPosts: 'التعليقات على المنشورات',
  newFollowers: 'متابعون جدد',
  mentions: 'الإشارات',
  save: 'حفظ',
  deleteAccount: 'حذف الحساب',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'احصل على إشعار عندما يقوم شخص ما بـ',
  likesYourPosts: 'الإعجاب بمنشوراتك',
  commentsOnYourPosts: 'التعليق على منشوراتك',
  followsYou: 'متابعتك',
  mentionsYou: 'الإشارة إليك',
  chooseNotifications: 'اختر الإشعارات التي تريد تلقيها',
  controlWhoInteracts: 'تحكم في من يمكنه التفاعل معك',
  manageAccountInfo: 'إدارة معلومات حسابك وتفضيلاتك',
  emailCannotBeChanged: 'لا يمكن تغيير البريد الإلكتروني لأسباب أمنية',
  
  // Common
  loading: 'جاري التحميل...',
  cancel: 'إلغاء',
  update: 'تحديث',
  submit: 'إرسال',
  back: 'رجوع',
  next: 'التالي',
  previous: 'السابق',
  online: 'متصل',
  offline: 'غير متصل',
  
  // Profile
  editProfile: 'تعديل الملف الشخصي',
  noBioYet: 'لا توجد سيرة ذاتية بعد.',
  followers: 'المتابعون',
  following: 'يتابع',
  recentActivity: 'النشاط الأخير',
  noPostsYet: 'لا توجد منشورات بعد',
  shareFirstPost: 'شارك منشورك الأول!',
  bio: 'السيرة الذاتية',
  dateOfBirth: 'تاريخ الميلاد',
  follow: 'متابعة',
  unfollow: 'إلغاء المتابعة',
  
  // Search
  discover: 'اكتشف',
  findPeopleStories: 'ابحث عن الأشخاص والقصص والأفكار المهمة بالنسبة لك',
  searchByName: 'البحث بالاسم أو العنوان أو #العلامة...',
  searchResults: 'نتائج البحث',
  noResultsFound: 'لم يتم العثور على نتائج',
  peopleFound: 'الأشخاص الموجودون',
  
  // Settings - Additional keys
  enterDisplayName: 'أدخل اسم العرض الخاص بك',
  saving: 'جاري الحفظ...',
  confirmDeleteAccount: 'هل أنت متأكد من أنك تريد حذف حسابك؟ لا يمكن التراجع عن هذا الإجراء.',
  accountDeletedSuccessfully: 'تم حذف الحساب بنجاح.',
  errorDeletingAccount: 'خطأ في حذف الحساب. يرجى المحاولة مرة أخرى.',
  settingsSavedSuccessfully: 'تم حفظ الإعدادات بنجاح!',
  failedToSaveSettings: 'فشل في حفظ الإعدادات. يرجى المحاولة مرة أخرى.',
  
  // Form component
  pleaseSignInToCreate: 'يرجى تسجيل الدخول لإنشاء منشور.',
  titleRequired: 'العنوان مطلوب لنشر منشور.',
  contentRequired: 'محتوى القصة مطلوب لنشر منشور.',
  contentTooShort: 'يجب أن يكون محتوى القصة 10 أحرف على الأقل.',
  postUpdatedSuccessfully: 'تم تحديث المنشور بنجاح!',
  postPublishedSuccessfully: 'تم نشر المنشور بنجاح!',
  pleaseSignInToCreateBlogs: 'يرجى تسجيل الدخول لإنشاء مدونات IdeaFlux الخاصة بك.',
  enterEngagingTitle: 'أدخل عنواناً جذاباً...',
  story: 'القصة',
  writeYourMasterpiece: 'اكتب تحفتك الفنية...',
  addTags: 'إضافة علامات...',
  add: 'إضافة',
  publishPost: 'نشر المنشور',
  
  // Post component
  linkCopiedToClipboard: 'تم نسخ الرابط إلى الحافظة! تم تحديث عداد المشاركة.',
  youAndOthers: 'أنت و {{count}} آخرون',
  unknownUser: 'مستخدم غير معروف',
  noImage: 'لا توجد صورة',
  deletePost: 'حذف المنشور',
  confirmDeletePost: 'هل أنت متأكد من أنك تريد حذف هذا المنشور؟',
};